var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10263 1.41208C4.46821 1.21734 4.6067 0.763104 4.41195 0.397527C4.2172 0.0319506 3.76297 -0.106534 3.39739 0.0882128C2.36539 0.637971 1.44451 1.37468 0.681627 2.26083C0.411381 2.57474 0.446779 3.04829 0.76069 3.31853C1.0746 3.58878 1.54815 3.55338 1.8184 3.23947C2.46006 2.49413 3.23462 1.87449 4.10263 1.41208ZM7.50001 14.0001C10.8137 14.0001 13.5 11.3139 13.5 8.00015C13.5 4.68644 10.8137 2.00015 7.50001 2.00015C4.1863 2.00015 1.50001 4.68644 1.50001 8.00015C1.50001 11.3139 4.1863 14.0001 7.50001 14.0001ZM10.5881 0.397527C10.7828 0.0319506 11.2371 -0.106534 11.6026 0.0882128C12.6346 0.637971 13.5555 1.37468 14.3184 2.26083C14.5886 2.57474 14.5532 3.04829 14.2393 3.31853C13.9254 3.58878 13.4519 3.55338 13.1816 3.23947C12.54 2.49413 11.7654 1.87449 10.8974 1.41208C10.5318 1.21734 10.3933 0.763104 10.5881 0.397527ZM8.125 5C8.125 4.65482 7.84518 4.375 7.5 4.375C7.15482 4.375 6.875 4.65482 6.875 5V8C6.875 8.34518 7.15482 8.625 7.5 8.625H10C10.3452 8.625 10.625 8.34518 10.625 8C10.625 7.65482 10.3452 7.375 10 7.375H8.125V5Z",
    fill: "#CBCED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimericon);
export default __webpack_public_path__ + "static/media/timericon.94c1684ed16345658d2a74088064d622.svg";
export { ForwardRef as ReactComponent };